import PasswordForm from './PasswordForm';

export default PasswordForm;
